import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Dropdown, Space, Typography, Button, message } from 'antd';
import {
  DashboardOutlined, TeamOutlined, SettingOutlined, CrownOutlined,
  UserOutlined, LogoutOutlined, RobotOutlined, EditOutlined, FileTextOutlined, TagsOutlined, ApiOutlined,
  HistoryOutlined
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation, Navigate } from 'react-router-dom';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

const AdminLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [adminUser, setAdminUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    console.log('=== AdminLayout 路由保护检查 ===');
    
    // 检查管理员登录状态
    const token = localStorage.getItem('admin_token');
    const user = localStorage.getItem('admin_user');
    
    console.log('检查localStorage:', {
      admin_token: token ? '存在' : '不存在',
      admin_user: user ? '存在' : '不存在'
    });
    
    if (!token || !user) {
      console.log('Token或用户信息缺失，重定向到登录页面');
      setLoading(false);
      navigate('/admin/login');
      return;
    }

    try {
      const parsedUser = JSON.parse(user);
      console.log('解析用户信息成功:', parsedUser);
      setAdminUser(parsedUser);
      setLoading(false);
    } catch (error) {
      console.error('解析管理员用户信息失败:', error);
      setLoading(false);
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    localStorage.removeItem('admin_user');
    message.success('已退出管理后台');
    navigate('/admin/login');
  };

  const menuItems = [
    {
      key: '/admin/dashboard',
      icon: <DashboardOutlined />,
      label: '仪表盘',
    },
    {
      key: '/admin/users',
      icon: <TeamOutlined />,
      label: '用户管理',
    },
    {
      key: '/admin/processing-history',
      icon: <HistoryOutlined />,
      label: '处理历史',
    },
    {
      type: 'group',
      label: '业务功能',
      children: [
        { key: '/admin/product-info', icon: <RobotOutlined />, label: '商品信息生成' },
        { key: '/admin/title-processing', icon: <EditOutlined />, label: '标题处理工具' },
        { key: '/admin/data-template', icon: <FileTextOutlined />, label: '数据组织与模板' },
        { key: '/admin/product-type', icon: <TagsOutlined />, label: '商品类型管理' },
        { key: '/admin/ai-providers', icon: <ApiOutlined />, label: 'AI提供商管理' },
        { key: '/admin/ai-prompts', icon: <FileTextOutlined />, label: 'AI提示词' },
      ]
    },
    {
      key: '/admin/settings',
      icon: <SettingOutlined />,
      label: '系统设置',
    },
  ];

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人资料',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
    },
  ];

  const handleMenuClick = ({ key }) => {
    navigate(key);
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px',
        color: '#1890ff'
      }}>
        正在验证管理员身份...
      </div>
    );
  }

  if (!adminUser) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sider 
        collapsible 
        collapsed={collapsed} 
        onCollapse={setCollapsed}
        theme="dark"
      >
        <div style={{ 
          height: 32, 
          margin: 16, 
          background: 'rgba(255, 255, 255, 0.3)',
          borderRadius: 6,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: 'white',
          fontWeight: 'bold'
        }}>
          {collapsed ? '管理' : '管理员后台'}
        </div>
        <Menu
          theme="dark"
          selectedKeys={[location.pathname]}
          mode="inline"
          items={menuItems}
          onClick={handleMenuClick}
        />
      </Sider>
      
      <Layout>
        <Header style={{ 
          padding: '0 24px', 
          background: '#fff',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          boxShadow: '0 1px 4px rgba(0,21,41,.08)'
        }}>
          <div>
            <CrownOutlined style={{ color: '#1890ff', marginRight: 8 }} />
            <Text strong>管理员后台</Text>
          </div>
          
          <Space>
            <Text>欢迎，</Text>
            <Dropdown
              menu={{ 
                items: userMenuItems,
                onClick: ({ key }) => {
                  if (key === 'logout') {
                    handleLogout();
                  }
                }
              }}
              placement="bottomRight"
            >
              <Button type="text">
                <Space>
                  <Avatar icon={<CrownOutlined />} />
                  {adminUser?.full_name || adminUser?.username}
                </Space>
              </Button>
            </Dropdown>
          </Space>
        </Header>
        
        <Content style={{ margin: '16px' }}>
          <div style={{ padding: '16px', background: '#fff', borderRadius: '8px' }}>
            <div style={{ marginBottom: '16px', color: '#1890ff', fontWeight: 'bold' }}>
              AdminLayout Content 区域 - 准备渲染子组件
            </div>
            <div style={{ marginBottom: '16px', color: '#52c41a', fontWeight: 'bold' }}>
              当前URL: {window.location.pathname}
            </div>
            <div style={{ border: '2px solid #1890ff', padding: '16px', borderRadius: '8px' }}>
              <div style={{ marginBottom: '8px', color: '#722ed1', fontWeight: 'bold' }}>
                Outlet 渲染区域开始：
              </div>
              <Outlet />
              <div style={{ marginTop: '8px', color: '#722ed1', fontWeight: 'bold' }}>
                Outlet 渲染区域结束
              </div>
            </div>
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;